import React from 'react';
import { Icon } from 'ui';

import ImgNegative from './img/emoji_negative.svg';
import ImgNeutral from './img/emoji_neutral.svg';
import ImgPositive from './img/emoji_positive.svg';

type Props = {
  rating: 0 | 1 | 2;
  size?: Extract<Icon['props']['size'], 'small' | 'large' | 'big' | 'massive'>;
};

function RatingEmoji({ rating, size = 'big' }: Props) {
  let imgSize: React.CSSProperties['fontSize'] = '45px';
  const baseStyles = { verticalAlign: 'middle' };

  switch (size) {
    case 'massive':
      imgSize = '101px';
      break;
    case 'large':
      imgSize = '40px';
      break;
    case 'small':
      imgSize = '25px';
      break;
    default:
      break;
  }

  switch (rating) {
    case 0:
      return (
        <img
          src={ImgNegative}
          alt={gettext('Bad')}
          style={{ height: imgSize, width: imgSize, maxWidth: imgSize, ...baseStyles }}
        />
      );
    case 1:
      return (
        <img
          src={ImgNeutral}
          alt={gettext('Good, but...')}
          style={{ height: imgSize, width: imgSize, maxWidth: imgSize, ...baseStyles }}
        />
      );
    case 2:
      return (
        <img
          src={ImgPositive}
          alt={gettext('Perfect')}
          style={{ height: imgSize, width: imgSize, maxWidth: imgSize, ...baseStyles }}
        />
      );
    default:
      return null;
  }
}

export default RatingEmoji;
